import request from 'superagent'
import prefix from 'superagent-prefix'
import { getRegion } from '@/libs/util'

const domain = { us: SERVICE_URL_US, asia: SERVICE_URL_ASIA }

export const authArgs = (token) => ['Authorization', `Bearer ${token}`]
export const region = getRegion()
export const url = (path) => prefix(domain[region] + '/' + path)

export default {
  notelists: {
    linkify (token) {
      return request
        .post('/linkify')
        .use(url(`api-${region}-notelists`))
        .set(...authArgs(token))
    },
    unlinkify (token) {
      return request
        .post('/unlinkify')
        .use(url(`api-${region}-notelists`))
        .set(...authArgs(token))
    }
  },
  memos: {
    highlight (token) {
      return request
        .post('/highlight')
        .use(url(`api-${region}-memos`))
        .set(...authArgs(token))
    },
    ocr (token) {
      return request
        .post('/ocr')
        .use(url(`api-${region}-memos`))
        .set(...authArgs(token))
    }
  },
  userbooks: {
    readingVolume (token) {
      return request
        .get('/reading-volume')
        .use(url(`api-${region}-userbooks`))
        .set(...authArgs(token))
    }
  },
  books: {
    search () {
      return request.get('/search').use(url(`api-${region}-books`))
    },
    get (isbn13) {
      return request.get(`/${isbn13}`).use(url(`api-${region}-books`))
    }
  },
  export () {
    return request.post('/').use(url(`api-${region}-export`))
  },
  search (token) {
    return request
      .get('/')
      .use(url(`api-${region}-search`))
      .set(...authArgs(token))
  },
  validatePurchase () {
    return request.post('/').use(url(`api-${region}-validatePurchase`))
  },
  sendFeedback () {
    return request.post('/').use(url(`api-${region}-sendFeedback`))
  },
  deleteAccount (token) {
    return request
      .post('/')
      .use(url(`api-${region}-deleteAccount`))
      .set(...authArgs(token))
  },
  services: {
    import (token) {
      return request
        .post('/import')
        .use(url(`api-${region}-services`))
        .set(...authArgs(token))
    },
    unlink (token) {
      return request
        .post('/unlink')
        .use(url(`api-${region}-services`))
        .set(...authArgs(token))
    }
  },
  recount (token) {
    return request
      .post('/')
      .use(url(`api-${region}-recount`))
      .set(...authArgs(token))
  }
}
